import { render, staticRenderFns } from "./SpecialTermsModal.vue?vue&type=template&id=2b2d589c&scoped=true"
import script from "./SpecialTermsModal.vue?vue&type=script&lang=js"
export * from "./SpecialTermsModal.vue?vue&type=script&lang=js"
import style0 from "./SpecialTermsModal.vue?vue&type=style&index=0&id=2b2d589c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b2d589c",
  null
  
)

export default component.exports